import { getLocale } from "../runtime";

const sv_itcountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Italy`
};

const itcountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_itcountryenglish(inputs)
	return "itCountryEnglish";
};

export { itcountryenglish as "itCountryEnglish" };